import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Toaster } from '../ui/sonner';
import { CookieBanner } from '../CookieBanner';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[hsl(210,33%,99%)]">
      <Header />
      <main className="flex-1 pt-16">
        {children}
      </main>
      <Footer />
      <CookieBanner />
      <Toaster position="bottom-right" />
    </div>
  );
};
